import React, { useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import LandingKitDigital from 'ui/pages/external/landingKitDigital'
import { IntlContext } from 'context/LocaleContext'
import { findMatchingLocale } from '../../libs/i18n'

const HomeKitDigital = () => {
  const { locale, changeLocale } = useContext(IntlContext)

  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.has('locale')) {
      const newLocale = findMatchingLocale(queryParams.get('locale'))
      if (newLocale && locale !== newLocale) {
        changeLocale(newLocale)
        queryParams.delete('locale')
        history.replace({
          search: queryParams.toString(),
        })
      }
    }
  })

  return <LandingKitDigital />
}

export default HomeKitDigital
